import styled from "@emotion/styled";

import { Button } from "~/components/common/button";
import { Icon } from "~/components/common/icon";

export const StyledIcon = styled(Icon)`
  color: var(--pswp-icon-color);
`;

export const StyledButton = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;

  inline-size: 44px;
  block-size: 44px;

  :hover {
    ${StyledIcon} {
      opacity: 0.8;
    }
  }
`;

export const StyledArrowUp = styled.div`
  inline-size: 0;
  block-size: 0;
  margin-block-start: -10px;

  border-inline-end: 10px solid transparent;
  border-block-end: 10px solid #ffffff;
  border-inline-start: 10px solid transparent;
`;

export const ShareContainer = styled.div`
  position: relative;
`;
